import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@sea-snag/ui';

import { useYearOptions, useYearSelection } from '../hooks/use-year';

/**
 * The app's one year control. Lives in the header next to the notification bell;
 * every screen follows it.
 */
export function YearSelect() {
  const { year, setYear } = useYearSelection();
  const options = useYearOptions();

  return (
    <Select value={String(year)} onValueChange={(v) => setYear(Number(v))}>
      <SelectTrigger className="h-8 w-[92px]" aria-label="Year">
        <SelectValue />
      </SelectTrigger>
      <SelectContent align="end">
        {options.map((y) => (
          <SelectItem key={y} value={String(y)}>
            {y}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
